module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list_nav_wrap nav_showcartype"
  }, [_c('h1', {
    staticClass: "list_nav_title clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.keyName))])]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix findall",
    attrs: {
      "click_type": "sale-brands"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('li', [_c('a', {
      class: {
        'listNav_active': ~~_vm.active === item.value
      },
      on: {
        "click": function($event) {
          _vm.doSelect(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62e3b72e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/NavContainer/ListNav/NavShowCarType.vue
// module id = 864
// module chunks = 5